/**
 * SkillDelivery Platform — WMS Showcase
 * Copyright © 2026 SKD RATWANI Technology & Software Solutions Pvt Ltd
 * All Rights Reserved.
 * PROPRIETARY AND CONFIDENTIAL
 *
 * Content authored by Lalit Ratwani, drawing from 22+ years of
 * Manhattan WMS implementation practice (2003-2026).
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import MetaBadge from './MetaBadge';

const CaseStudyCard = ({ study }) => {
  const navigate = useNavigate();

  const goToDetail = () => {
    // Domain-aware — case_studies is a multi-domain table; the card is
    // reused by both /domain/wms/case-studies and /domain/civil/case-studies.
    // Fallback to 'wms' preserves prior behaviour if a row somehow lacks a domain.
    const domain = study.domain || 'wms';
    navigate(`/domain/${domain}/case-studies/${study.slug}`);
  };

  return (
    <button
      type="button"
      onClick={goToDetail}
      className="group flex flex-col text-left bg-white border border-brand-border rounded-brandCard p-6 transition-all duration-200 hover:border-brand-cyan hover:-translate-y-0.5 hover:shadow-brand focus:outline-none focus:ring-2 focus:ring-brand-cyan focus:ring-offset-2"
    >
      {/* Meta badge row */}
      <div className="flex flex-wrap gap-1.5 mb-4">
        <MetaBadge value={study.industry} variant="cyan" />
        <MetaBadge value={study.manhattan_version} variant="blue" />
        <MetaBadge value={study.region} variant="muted" />
      </div>

      <h3 className="font-bold text-base text-brand-text leading-snug">
        {study.title}
      </h3>

      {study.client_descriptor && (
        <p className="mt-1.5 text-sm text-brand-text2 italic">
          {study.client_descriptor}
        </p>
      )}

      {study.years && (
        <p className="mt-0.5 text-xs text-brand-muted2">{study.years}</p>
      )}

      {study.summary && (
        <p className="mt-3 text-sm text-brand-muted leading-relaxed line-clamp-3">
          {study.summary}
        </p>
      )}

      <p className="mt-auto pt-4 text-sm font-semibold text-brand-cyan group-hover:translate-x-1 transition-transform">
        Read case study →
      </p>
    </button>
  );
};

export default CaseStudyCard;
